export const ContactsListMobile = () => {
  return <div>ContactsListMobile</div>;
};
